
// import React, { useState } from "react";
// import {
//   TableContainer,
//   Paper,
//   Table,
//   TableHead,
//   TableRow,
//   TableCell,
//   TableBody,
//   TextField,
//   Button,
// } from "@material-ui/core";
// import { getMasterTableData } from "../../ReduxStore/MastertableSlice";
// import { useDispatch } from "react-redux";
// import { ToastContainer, toast } from 'react-toastify';
// import 'react-toastify/dist/ReactToastify.css';

// const AssetTable = ({ headers }) => {
//   const dispatch = useDispatch();

//   // Initialize rows with one empty object representing one row
//   const [rows, setRows] = useState([{ ...headers.reduce((acc, header) => ({ ...acc, [header]: "" }), {}) }]);
//   const [loading, setLoading] = useState(false);
//   const [masterData, setMasterData] = useState();
//   // Add a new row
//   const handleAddRow = () => {
//     setRows([...rows, { ...headers.reduce((acc, header) => ({ ...acc, [header]: "" }), {}) }]);
//   };

//   // Remove a specific row
//   const handleRemoveRow = (index) => {
//     const updatedRows = rows.filter((_, rowIndex) => rowIndex !== index);
//     setRows(updatedRows);
//   };

//   // Handle input change for each row and column
//   const handleInputChange = (rowIndex, header, value) => {
//     const updatedRows = rows.map((row, index) =>
//       index === rowIndex ? { ...row, [header]: value } : row
//     );
//     setRows(updatedRows);
//   };

//   const handleSearch = async (rowIndex) => {
//     const assetCode = rows[rowIndex]["Asset Code/No"];
//     console.log(`Searching for Asset Code/No: ${assetCode}`);
//     // Implement your search logic here (e.g., API call or filter)
//     try {
//       setLoading(true)
//       const action = dispatch(getMasterTableData({ page: 1, limit: 500, queryParams: `asset_no=${assetCode}` }));
//       const res = await action.unwrap();
//       console.log("ALL DATA", res.result.data)
//       if (res.result.data) {
//         setLoading(false)
//         // if (res.result.data.length > 0) {
//         //   setMasterData(res.result.data)
//         //   toast.success("Asset Found!")
//         // } else {
//         //   toast.info("Asset Not Found!")
//         // }
//         if (res.result.data.length > 0) {
//           const assetData = res.result.data[0]; // Assuming one asset is returned
//           console.log("check", assetData)
//           setMasterData(assetData);

//           // Populate the fields with asset master data
//           const updatedRows = rows.map((row, index) =>
//             index === rowIndex
//               ? {
//                 ...row,
//                 "Asset Code/No": assetData["asset_no"] || "",
//                 "Asset description": assetData["asset_text"] || "",
//                 "Vendor": assetData["Vendor"] || "",
//                 "Location": assetData["Location"] || "",
//                 // Add more fields as needed
//                 // Match headers with assetData keys
//                 "Cost Center": assetData["cost_center"] || "",
//                 "Plant Location": assetData["Plant Location"] || "",
//                 "Model/ Car": assetData["Model/ Car"] || "",
//               }
//               : row
//           );
//           setRows(updatedRows);

//           toast.success("Asset Found!");
//         } else {
//           toast.info("Asset Not Found!");
//         }
//       };
//     } catch (error) {
//       console.error("Error in okHandler:", error);
//       toast.error(error.message || "Asset Not Found!");
//     } finally {
//       setLoading(false)
//     }
//   };

//   return (
//     <>
//       <TableContainer component={Paper} style={{ marginBottom: 12 }}>
//         <Table style={{ minWidth: 4100 }}>
//           <TableHead>
//             <TableRow>
//               <TableCell>Action</TableCell>
//               <TableCell>Remove</TableCell> {/* Add header for remove button */}
//               {headers.map((header, index) => (
//                 <TableCell key={index}>{header}</TableCell>
//               ))}

//             </TableRow>
//           </TableHead>
//           <TableBody>
//             {rows.map((row, rowIndex) => (
//               <TableRow key={rowIndex}>
//                 <TableCell>
//                   <Button
//                     variant="contained"
//                     color="secondary"
//                     onClick={() => handleRemoveRow(rowIndex)}
//                     disabled={rows.length === 1} // Prevent removing the last row
//                   >
//                     Remove
//                   </Button>
//                 </TableCell>
//                 <TableCell>
//                   <Button
//                     variant="contained"
//                     color="primary"
//                     onClick={() => handleSearch(rowIndex)}
//                   >
//                     Search
//                   </Button>
//                 </TableCell>
//                 {headers.map((header, colIndex) => (
//                   <TableCell key={colIndex}>
//                     <TextField
//                       variant="outlined"
//                       size="small"
//                       value={row[header]}
//                       onChange={(e) => handleInputChange(rowIndex, header, e.target.value)}
//                     />
//                   </TableCell>
//                 ))}

//               </TableRow>
//             ))}
//           </TableBody>
//         </Table>
//       </TableContainer>

//       <Button
//         variant="contained"
//         color="primary"
//         onClick={handleAddRow}
//         style={{ marginRight: 8 }}
//       >
//         Add Row
//       </Button>
//       <ToastContainer />
//     </>
//   );
// };

// export default AssetTable;


import React, { useEffect, useState } from "react";
import {
  TableContainer,
  Paper,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  TextField,
  Button,
  IconButton,
} from "@material-ui/core";
import { getMasterTableData } from "../../ReduxStore/MastertableSlice";
import { useDispatch } from "react-redux";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { AssetDisposaluploadFile } from "../../ReduxStore/AssetDisposalSlice";
import GetAppIcon from '@material-ui/icons/GetApp';

const AssetTable = ({ headers, Width, onRowsChange, rowsData, finalSub = false, log_id = '' }) => {
  const dispatch = useDispatch();
  const [rows, setRows] = useState(
    rowsData && rowsData.length > 0
      ? rowsData
      : [{ ...headers.reduce((acc, header) => ({ ...acc, [header]: "" }), {}) }]
  );

  useEffect(() => {
    if (rowsData && rowsData.length > 0) {
      setRows(rowsData);
    }
  }, [rowsData]);

  // Initialize rows with one empty object representing one row
  // const [rows, setRows] = useState([{ ...headers.reduce((acc, header) => ({ ...acc, [header]: "" }), {}) }]);
  const [loading, setLoading] = useState(false);
  const [masterData, setMasterData] = useState();
  const [initialBusinessUnit, setInitialBusinessUnit] = useState(null);
  const [files, setFiles] = useState(Array(rows.length).fill(null));
  const [fileSelected, setFileSelected] = useState(Array(rows.length).fill(false));

  const handleFileChange = (rowIndex, event) => {
    const selectedFile = event.target.files[0];
    setFiles((prevFiles) => {
      const newFiles = [...prevFiles];
      newFiles[rowIndex] = selectedFile; // Update the file for the specific row
      return newFiles;
    });
    // Update file selected status
    setFileSelected((prevStatus) => {
      const newStatus = [...prevStatus];
      newStatus[rowIndex] = true; // Mark this row as having a file selected
      return newStatus;
    });
  };

  const handleUpload = async (rowIndex) => {
    const file = files[rowIndex];
    const assetNo = rows[rowIndex]['Asset Code / No.'];
    if (file) {
      const formData = new FormData();
      formData.append(file.name, file);
      formData.append('disposal_logs_id', log_id);
      formData.append('hid', rowIndex + 1);
      const fileDescription = `finalsubmission_${assetNo}`;
      formData.append('file_description', fileDescription);
      try {
        // setUpLoading(true)
        const action = dispatch(AssetDisposaluploadFile(formData));
        const res = await action.unwrap();
        console.log("res from pv log:", res);
        if (res.StatusCode === 200) {
          // setUpLoading(false)
          console.log("check upload file", res.response)
          // setshowUploadedImage(true);
          toast.success("File Upload Done");
          // setUploadedImgUrl(res.response.s3_file_url);
          // setFileName(res.response.file_name);
          // console.log("imageURL", uploadedImgUrl, fileName)
        } else {
          toast.error("Something went wrong!")
        }
      } catch (error) {
        console.error("Error in okHandler:", error);
        toast.error(error.message || "Something went wrong!");
      }
    } else {
      toast.warning(`No file selected for row ${assetNo}`);
      // console.log(`No file selected for row ${rowIndex}`);
    }
  };



  // Add a new row
  const handleAddRow = () => {
    setRows([...rows, { ...headers.reduce((acc, header) => ({ ...acc, [header]: "" }), {}) }]);
  };

  // Remove a specific row
  const handleRemoveRow = (index) => {
    const updatedRows = rows.filter((_, rowIndex) => rowIndex !== index);
    setRows(updatedRows);
  };

  // Handle input change for each row and column
  const handleInputChange = (rowIndex, header, value) => {
    const updatedRows = rows.map((row, index) =>
      index === rowIndex ? { ...row, [header]: value } : row
    );
    setRows(updatedRows);
    if (onRowsChange) {
      onRowsChange(updatedRows);
    }
  };

  // Handle search for asset code
  const handleSearch = async (rowIndex) => {
    const assetCode = rows[rowIndex]["Asset Code/No"];
    // console.log(`Searching for Asset Code/No: ${assetCode}`);
    // Implement your search logic here (e.g., API call or filter)
    try {
      setLoading(true);
      const action = dispatch(getMasterTableData({ page: 1, limit: 500, queryParams: `asset_no=${assetCode}` }));
      const res = await action.unwrap();
      // console.log("ALL DATA", res.result.data);
      if (res.result.data) {
        setLoading(false);
        if (res.result.data.length > 0) {
          const assetData = res.result.data[0]; // Assuming one asset is returned
          // setMasterData(assetData);
          const businessUnit = assetData.business_unit;

          // If it's the first search, store the initial business unit
          if (!initialBusinessUnit) {
            setInitialBusinessUnit(businessUnit);
          }

          // Compare with the initial business unit for subsequent searches
          if (initialBusinessUnit && businessUnit !== initialBusinessUnit) {
            toast.error(`You can only select assets from Business Unit: ${initialBusinessUnit}`);
            return; // Stop further processing
          }

          // Populate the fields with asset master data
          const updatedRows = rows.map((row, index) =>
            index === rowIndex
              ? {
                ...row,
                "Asset Code/No": assetData["asset_no"] || "",
                // "Asset Code/No": assetData.asset_no.slice(3) || "",
                "Asset Description": assetData["asset_text"] || "",
                "PO No.": assetData['po_no'] || "",
                "Present Location": assetData['Plant Location'] || "",
                "Name of Vendor": assetData['Supplier Name'] || "",
                "Vendor Code": assetData["Vendor Code"] || "",
                "Location": assetData["Location"] || "",
                "Manufacturer Serial Number": assetData["serial_no"] || "",
                "Cost Center": assetData["cost_center"] || "",
                "Model/ Project of Asset": assetData["Model/Project"] || "",
                "Quantity": assetData["quantity"] || "",
                "Original asset value": assetData["original_asset"] || "",
                "Business Unit": assetData['business_unit'] || "",
                // "BusA Description":assetData['busA_Description']
              }
              : row
          );
          onRowsChange(updatedRows);
          setRows(updatedRows);

          toast.success("Asset Found!");
        } else {
          toast.info("Asset Not Found!");
        }
      }
    } catch (error) {
      console.error("Error in handleSearch:", error);
      toast.error(error.message || "Asset Not Found!");
    } finally {
      setLoading(false);
    }
  };

  // Only render buttons if Width is not 2000
  const showButtons = Width !== "2000";


  // Use useEffect to send rows data to the parent component whenever rows are updated
  useEffect(() => {
    if (onRowsChange) {
      onRowsChange(rows); // Send rows data to the parent
    }
  }, [rows, onRowsChange]);


  return (
    <>
      <TableContainer component={Paper} style={{ marginBottom: 12 }}>
        <Table style={{ minWidth: `${Width}px` }}>
          <TableHead>
            <TableRow>
              {showButtons && <TableCell>Action</TableCell>}
              {showButtons && <TableCell>Remove</TableCell>}
              {headers.map((header, index) => (
                <TableCell key={index}>{header}</TableCell>
              ))}
              {finalSub && <TableCell>File</TableCell>}
              {finalSub && <TableCell>Action</TableCell>}
            </TableRow>
          </TableHead>
          <TableBody>
            {rows.map((row, rowIndex) => (
              <TableRow key={rowIndex}>
                {showButtons && (
                  <TableCell>
                    <Button
                      variant="contained"
                      color="secondary"
                      onClick={() => handleRemoveRow(rowIndex)}
                      disabled={rows.length === 1}
                    >
                      Remove
                    </Button>
                  </TableCell>
                )}
                {showButtons && (
                  <TableCell>
                    <Button
                      variant="contained"
                      color="primary"
                      onClick={() => handleSearch(rowIndex)}
                    >
                      Search
                    </Button>
                  </TableCell>
                )}
                {/* {headers.map((header, colIndex) => (
                  <TableCell key={colIndex}>
                    <TextField
                      variant="outlined"
                      size="small"
                      value={row[header]}
                      onChange={(e) => handleInputChange(rowIndex, header, e.target.value)}
                    />
                  </TableCell>
                ))} */}
                {headers.map((header, colIndex) => (
                  <TableCell key={colIndex}>
                    {/* For the 'File URL' column, show a download icon */}
                    {header === "File URL" ? (
                      row[header] ? (
                        <IconButton
                          color="primary"
                          component="a"
                          href={row[header]}
                          target="_blank"
                          rel="noopener noreferrer"
                          download
                        >
                          <GetAppIcon />
                        </IconButton>
                      ) : (
                        "No file available"
                      )
                    ) : header === "UTR Date" ? (
                      <TextField
                        type="date"
                        variant="outlined"
                        size="small"
                        value={row[header]}
                        onChange={(e) => handleInputChange(rowIndex, header, e.target.value)}
                      />
                    ) : (
                      <TextField
                        variant="outlined"
                        size="small"
                        value={row[header]}
                        onChange={(e) => handleInputChange(rowIndex, header, e.target.value)}
                      />
                    )}
                    {/* {header === "UTR Date" ? (
                      <TextField
                        type="date"
                        variant="outlined"
                        size="small"
                        value={row[header]}
                        onChange={(e) => handleInputChange(rowIndex, header, e.target.value)}
                      />
                    ) : (
                      <TextField
                        variant="outlined"
                        size="small"
                        value={row[header]}
                        onChange={(e) => handleInputChange(rowIndex, header, e.target.value)}
                      />
                    )} */}
                  </TableCell>
                ))}
                {finalSub && (
                  <>

                    <TableCell>
                      <input
                        type="file"
                        style={{ display: 'none' }} // Hide the file input
                        id={`file-upload-${rowIndex}`} // Unique ID for the input
                        onChange={(e) => handleFileChange(rowIndex, e)} // Handle file selection
                      />
                      <label htmlFor={`file-upload-${rowIndex}`}>
                        <Button variant="contained" color="primary" component="span">
                          {fileSelected[rowIndex] ? "Selected" : "Select"}
                        </Button>
                      </label>
                    </TableCell>
                    <TableCell>
                      <Button
                        variant="contained"
                        color="primary"
                        onClick={() => handleUpload(rowIndex)} // Trigger the upload
                      >
                        Upload
                      </Button>
                    </TableCell>
                  </>
                )}

              </TableRow>
            ))}

          </TableBody>
        </Table>
      </TableContainer>

      {/* Conditionally render the "Add Row" button */}
      {showButtons && (
        <Button
          variant="contained"
          color="primary"
          onClick={handleAddRow}
          style={{ marginRight: 8 }}
        >
          Add Row
        </Button>
      )}

      <ToastContainer />
    </>
  );
};

export default AssetTable;





// import React, { useState } from "react";
// import {
//   TableContainer,
//   Paper,
//   Table,
//   TableHead,
//   TableRow,
//   TableCell,
//   TableBody,
//   TextField,
//   Button,
// } from "@material-ui/core";

// const AssetTable = () => {
//   const headers = [
//     "Asset Description",
//     "Asset Type",
//     "PO No.",
//     "PO Line Item No.",
//     "PO Line Item Description",
//     "Asset Type Selection",
//     "Present Location",
//     "Name of Vendor",
//     "Vendor Code",
//     "Year of Purchase/Installation",
//     "Name of Manufacturer",
//     "Country of Origin",
//     "Manufacturer Serial Number",
//     "Model/ Project of Asset",
//     "Number of Loose Parts/Aggregates",
//     "Quantity",
//     "Weight of Asset(in kg)",
//     "Overall Size of Asset(H x W x L)",
//     "Performance expected to be achieved by the Asset",
//     "Performance achieved by the Asset",
//     "Major defects in the Asset",
//     "Condition of the Asset",
//     "Are any parts missing",
//     "Original asset value",
//     "Present written down value",
//   ];

//   // Initialize with one empty row with keys for each header
//   const [rows, setRows] = useState([
//     headers.reduce((acc, header) => ({ ...acc, [header]: "" }), {}),
//   ]);

//   // Add a new empty row
//   const handleAddRow = () => {
//     setRows([
//       ...rows,
//       headers.reduce((acc, header) => ({ ...acc, [header]: "" }), {}),
//     ]);
//   };

//   // Remove the last row
//   const handleRemoveRow = () => {
//     if (rows.length > 1) {
//       setRows(rows.slice(0, -1));
//     }
//   };

//   // Handle input change for each cell
//   const handleInputChange = (rowIndex, header, value) => {
//     const updatedRows = [...rows];
//     updatedRows[rowIndex][header] = value;
//     setRows(updatedRows);
//   };

//   return (
//     <>
//       <TableContainer component={Paper} style={{ marginBottom: 12 }}>
//         <Table style={{ minWidth: 4100 }}>
//           <TableHead>
//             <TableRow>
//               {headers.map((header, index) => (
//                 <TableCell key={index}>{header}</TableCell>
//               ))}
//             </TableRow>
//           </TableHead>
//           <TableBody>
//             {rows.map((row, rowIndex) => (
//               <TableRow key={rowIndex}>
//                 {headers.map((header, colIndex) => (
//                   <TableCell key={colIndex}>
//                     <TextField
//                       variant="outlined"
//                       size="small"
//                       value={row[header]}
//                       onChange={(e) =>
//                         handleInputChange(rowIndex, header, e.target.value)
//                       }
//                     />
//                   </TableCell>
//                 ))}
//               </TableRow>
//             ))}
//           </TableBody>
//         </Table>
//       </TableContainer>

//       <Button
//         variant="contained"
//         color="primary"
//         onClick={handleAddRow}
//         style={{ marginRight: 8 }}
//       >
//         Add Row
//       </Button>
//       <Button
//         variant="contained"
//         color="secondary"
//         onClick={handleRemoveRow}
//         disabled={rows.length === 1} // Prevent removing the last row
//       >
//         Remove Row
//       </Button>

//       {/* Debugging: Display the current state of rows */}
//       <pre>{JSON.stringify(rows, null, 2)}</pre>
//     </>
//   );
// };

// export default AssetTable;
